module.exports = __webpack_public_path__ + "static/img/lucilas-2.7820ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/lucilas-2.jpg
// module id = cOHN
// module chunks = 1